import PlgIcon from "plg/shell/PlgIcon";
import MeetingIcon from "plg/meeting/MeetingIcon";

interface Props {
  title: string;
  description: string;
  onRequestHire: () => void;
  /** PLG: the row asks for a meeting (prototype askRow, calendar-check tile) instead of Request a hire. */
  meeting?: boolean;
  /** PLG: a meeting was already requested; the button is disabled and says so. */
  sent?: boolean;
}

/** A Request a hire / Request a meeting row that sits in the talent list like a card (prototype .tnudge). */
function HireNudgeRow({ title, description, onRequestHire, meeting = false, sent = false }: Props) {
  return (
    <article className="talent-network__nudge" data-testid="hire-nudge">
      <div className={`talent-network__nudge-icon${meeting ? " talent-network__nudge-icon--meeting" : ""}`}>
        {meeting ? <MeetingIcon name="calCheck" size={22} /> : <PlgIcon name="userPlus" size={26} />}
      </div>
      <div className="talent-network__nudge-body">
        <h3 className="talent-network__nudge-title">{title}</h3>
        <p className="talent-network__nudge-desc">{description}</p>
        <div className="talent-network__nudge-actions">
          <button type="button" className="talent-network__nudge-cta" onClick={onRequestHire} disabled={meeting && sent}>
            {meeting && sent ? "Meeting requested" : meeting ? "Request a meeting" : "Request a hire"}
          </button>
        </div>
      </div>
    </article>
  );
}

export default HireNudgeRow;
